module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('stepTitle', {
    attrs: {
      "navItems": ['Live Culture'],
      "index": 1,
      "step": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container my-4 px-0 py-5",
    staticStyle: {
      "background": "#fff",
      "min-height": "80vh"
    }
  }, [(this.$route.name === 'ar_lesson') ? _c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "tag-boxes"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "position": "absolute",
      "bottom": "0"
    }
  }, [_c('div', {
    staticClass: "tag-body mx-3",
    class: {
      'active': _vm.isLesson
    },
    on: {
      "click": _vm.goLessonPage
    }
  }, [_vm._v(_vm._s(_vm.$t('lessons')))]), _vm._v(" "), (this.$store.state.auth.userRole === 'Teacher') ? _c('div', {
    staticClass: "tag-body mx-3",
    class: {
      'active': !_vm.isLesson
    },
    on: {
      "click": _vm.goResourcePage
    }
  }, [_vm._v(_vm._s(_vm.$t('teachers_resources')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex ",
    staticStyle: {
      "margin-right": "50px"
    }
  }, [_c('div', {
    staticClass: "m-auto type-selecter px-5"
  }, [_c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'search']
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form_input",
    staticStyle: {
      "height": "1.5rem"
    },
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "blur": _vm.updateSearch,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updateSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "back-icon pointer my-4",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "src": require("../../../assets/image/icon/close_lesson.png")
    },
    on: {
      "click": _vm.previousPage
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "inputSearchTxt": _vm.searchTxt
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20a3c224!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/ar/ARLayout.vue
// module id = 759
// module chunks = 3